(function () {
  function initRail(root) {
    const viewport = root.querySelector("[data-z21-mega-viewport]");
    const prev = root.querySelector(".z21-mega-rail__nav--prev");
    const next = root.querySelector(".z21-mega-rail__nav--next");
    if (!viewport || !prev || !next) return;

    function getStep() {
      const firstItem = viewport.querySelector(".z21-mega-collections__item");
      const itemW = firstItem ? firstItem.getBoundingClientRect().width : 300;
      return Math.max(200, Math.round(itemW * 1.1));
    }

    prev.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      viewport.scrollBy({ left: -getStep(), behavior: "smooth" });
    });

    next.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      viewport.scrollBy({ left: getStep(), behavior: "smooth" });
    });
  }

  function initAll() {
    document.querySelectorAll(".z21-mega-rail").forEach(initRail);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();